import { useState } from "react";
import HexisColorPalette from "@/components/HexisColorPalette";
import { allHexisColors, hexisS5000Colors, hexisAirReleaseColors } from "@/data/hexisColors";

export const TestHexisColors = () => {
  const [selectedColor, setSelectedColor] = useState(null);

  return (
    <div className="pt-24 pb-16">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="mb-8">
          <p className="text-muted-foreground text-sm uppercase tracking-wider">Test Page</p>
          <h1 className="font-heading text-4xl font-bold">HEXIS Vinyl Color Palette</h1>
          <p className="text-muted-foreground mt-2">
            Complete color collection including S5000 Standard and Air Release (HX20000 & HX30000) series
          </p>
          <div className="flex gap-4 mt-4 text-sm">
            <span className="px-3 py-1 bg-gray-100 rounded-full">
              Total: <strong>{allHexisColors.length}</strong> colors
            </span>
            <span className="px-3 py-1 bg-blue-50 rounded-full text-blue-700">
              S5000: <strong>{hexisS5000Colors.length}</strong>
            </span>
            <span className="px-3 py-1 bg-green-50 rounded-full text-green-700">
              Air Release: <strong>{hexisAirReleaseColors.length}</strong>
            </span>
          </div>
        </div>

        <div className="bg-white border rounded-lg p-6">
          <HexisColorPalette 
            onSelectColor={setSelectedColor}
            selectedColor={selectedColor}
            showAllSeries={true}
          />
        </div>

        {selectedColor && (
          <div className="mt-8 p-6 bg-white border rounded-lg">
            <h2 className="font-bold text-xl mb-4">Selected Color Details</h2>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              <div>
                <p className="text-sm text-muted-foreground">Color Name</p>
                <p className="font-bold">{selectedColor.name}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Product Code</p>
                <p className="font-bold">{selectedColor.code}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Category</p>
                <p className="font-bold">{selectedColor.category}</p>
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Hex Value</p>
                <p className="font-bold">{selectedColor.hex}</p>
              </div>
              {selectedColor.series && (
                <div>
                  <p className="text-sm text-muted-foreground">Series</p>
                  <p className="font-bold">{selectedColor.series}</p>
                </div>
              )}
              {selectedColor.finish && (
                <div>
                  <p className="text-sm text-muted-foreground">Finish</p>
                  <p className="font-bold">{selectedColor.finish}</p>
                </div>
              )}
            </div>
            <div className="mt-4">
              <p className="text-sm text-muted-foreground mb-2">Color Preview</p>
              <div 
                className="h-24 rounded-lg border-2 border-gray-300"
                style={{ backgroundColor: selectedColor.hex }}
              />
            </div>
          </div>
        )}

        <div className="mt-8 p-4 bg-green-50 border border-green-200 rounded-lg">
          <p className="text-sm text-green-800">
            <strong>Test Status:</strong> Color palette successfully expanded with Air Release (SKINTAC) series.
            Now includes <strong>{allHexisColors.length}</strong> colors across 3 series:
          </p>
          <ul className="mt-2 text-sm text-green-700 list-disc list-inside">
            <li><strong>S5000</strong> - Standard Polymeric Sign Vinyl ({hexisS5000Colors.length} colors)</li>
            <li><strong>HX20000</strong> - Air Release Cast Vinyl with HEX-PRESS liner ({hexisAirReleaseColors.filter(c => c.series === "HX20000").length} colors)</li>
            <li><strong>HX30000</strong> - Premium Air Release with Chrome & Special Effects ({hexisAirReleaseColors.filter(c => c.series === "HX30000").length} colors)</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TestHexisColors;
